import { getCookie } from "@insite/client-framework/Common/Cookies";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import FitImage from "@ucs/Components/Common/FitImage";
import setIsLocalSelectedPLP from "@ucs/Store/Custom/SetIsLocalSelectedPLP";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

interface OwnProps {
    link: string;
    name: string;
    image: string;
    width: number;
    height: number;
    minWidth?: string;
    minHeight?: string;
}

const mapDispatchToProps = {
    setIsLocalSelectedPLP
}

type Props = ResolveThunks<typeof mapDispatchToProps> & OwnProps;

const StyledLink = styled.a`
    position: absolute;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50.8%, rgba(0, 0, 0, 0.65) 100%);    
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    padding: 20px 24px;
    font-size: 36px;
    font-weight: 400;
    color: ${UCSColors.gray10};

    ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`
                font-size: 22px;
            `,
            css`
                font-size: 22px;
            `,
            css``,
            css``,
            css``,
        ])};
`;

const CategoryProductTypeTile: FC<Props> = props => {
    const { link, name, image, width, height, minWidth, minHeight, setIsLocalSelectedPLP } = props;

    const clickHandler = (link: string) => {
        setIsLocalSelectedPLP({ isLocalSelectedPLP: true })
        const locationFilterId = getCookie("LocationBasedAttributeValue") || "";
        if (locationFilterId !== "") {
            window.location.href = `${link}?attributeValueIds=${locationFilterId}`;
        }
        else {
            window.location.href = link;
        }
    }

    const imageContainerStyles = {
            css: css`
                width: 100%;
                position: relative;
                overflow: hidden;            
                display: inline-block;
                height: 315px;
                width: 315px;
                min-width: ${minWidth || "0"};
                min-height: ${minHeight || "0"};
                ${({ theme}) =>
                    breakpointMediaQueries(theme, [
                        css`
                            height: calc(${height}px * 0.52);
                            width: calc(${width}px * 0.52);
                        `,
                        css`
                            height: calc(${height}px * 0.63);
                            width: calc(${width}px * 0.63);
                        `,
                        css`
                            height: calc(${height}px * 0.75);
                            width: calc(${width}px * 0.75);
                        `,
                        css`
                            height: calc(${height}px * 0.85);
                            width: calc(${width}px * 0.85);
                        `,
                        css`
                            height: ${height}px;
                            width: ${width}px;
                        `,
                    ])};
            `,
        };

    return (
        <FitImage image={image} focalPoint="center" containerStyles={imageContainerStyles}>
            <StyledLink onClick={() => clickHandler(link)}>
                <span>{name}</span>
            </StyledLink>
        </FitImage>
    );
};
export default connect(null, mapDispatchToProps)(CategoryProductTypeTile);
